import React, { useContext, useEffect, useRef, useState } from 'react'
import { Toast } from 'primereact/toast'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'


import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid'
import Card from '../../../../Base/Components/Card/Card'
import { useForm } from '../../../../Base/Hooks/useForm'
import { toastShow } from '../../../../Base/Services/ToastService'
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext'
import Loader from '../../../../Base/Components/Loader/Loader'
import { getDateTimeStringSQL } from '../../../../Base/Services/Moment/Luxon'


import { getUltimoID, getRequisa, getStatusPurchaseDetails, guardarEncabezadoRequisa } from '../../../../API/Compras/Requisas/PurchaseRequests'
import EncabezadoRequisicion from './Encabezado_Requisicion/EncabezadoRequisicion'
import { getDetalleRequisa, guardarDetallesRequisas } from '../../../../API/Compras/Requisas/PurchareDetailsRequests'
import { getCurrency } from '../../../../API/Global/Currency/CurrencyRequests'
import { getUnits } from '../../../../API/Global/Units/UnitsRequests'
import ProductosOverlayPanel from './OverlayPanels/ProductosOverlayPanel'
import ProveedorOverlayPanel from './OverlayPanels/ProveedorOverlayPanel'
import { Dropdown } from 'primereact/dropdown'
import { getAreas } from '../../../../API/Global/Areas/AreasRequests'
import { getAgentesCompras, getAgentesFirma } from '../../../../API/Global/Agentes/AgentesRequests'
import { getPermisoCostosUser } from '../../../../API/IT/Usuarios/AccesosUserRequets'
import ModalFull from '../../../../Base/Components/Dialog/ModalFull'
import OrdenesComprasCrud from '../../Ordenes/OrdenesComprasCrud'


const RequisaComprasModalCrud = ({ idRequisa }) => {

    const { userAuth } = useContext(AuthContext);

    const [detalles, setDetalles] = useState([]);
    const [habilitar, setHabilitar] = useState(true);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const [estados, setEstados] = useState([]);
    const [currencys, setCurrencys] = useState([]);
    const [units, setUnits] = useState([]);
    const [areas, setAreas] = useState([]);
    const [agentes, setAgentes] = useState([]);
    const [agentesCompras, setAgentesCompras] = useState([]);
    const [permisoCostos, setpermisoCostos] = useState(false);
    const [ordenDialog, setOrdenDialog] = useState(false);
    const [orderToShow, setOrderToShow] = useState(null);
    const [habilitarOrden, setHabilitarOrden] = useState(false)



    const prioridades = [
        { id: 1, prioridad: "Urgente" },
        { id: 2, prioridad: "Alta" },
        { id: 3, prioridad: "Media" },
        { id: 4, prioridad: "Baja" }
    ]

    const tipos = [
        { id: 1, tipo: "Local" },
        { id: 2, tipo: "Online" },
        { id: 3, tipo: "Internacional" },
        { id: 4, tipo: "Proyecto" },
        { id: 5, tipo: "Caja Chica" },
        { id: 6, tipo: "Regalia" }
    ]

    const toast = useRef(null);
    const estasdosConFirma = [172, 3328];

    const initialValues = {
        Date: new Date(),
        UserCreate: userAuth.Usuario,
        TienePrecio: false,
        IdStatus: 169,
        StatusName: 'Creada',
        IdPurchaseRequest: -1,
        PurchaseRequest: idRequisa ? idRequisa : '',
    }

    const onHideModalOC = () => {
        setOrdenDialog(false);
        setOrderToShow(undefined);
        setHabilitar(false);
    }

    const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues)
    const getInfoNew = async () => {
        setLoading(true);
        const ultimo = await getUltimoID() + 1;
        let year = (new Date().getFullYear()).toString().substr(-2);
        let id = "PR" + year + (ultimo.toString().padStart(5, "0"));
        const agentesComprasTempo = await getAgentesCompras();
        const edan = agentesComprasTempo.find(agente => agente.IdAgent === 1673);
        const d = {
            ...values,
            IdPurchaseRequest: -100,
            PurchaseRequest: id,
            AssignedTo: edan,
        }
        setTimeout(() => {
            setValues(d);
        }, 300);
        setLoading(false);
    }

    const getInfo = async () => {
        const t = await getStatusPurchaseDetails();
        setEstados(t);
        const c = await getCurrency();
        setCurrencys(c);
        const u = await getUnits();
        setUnits(u);
        const areas = await getAreas();
        setAreas(areas);
        const agentesTempo = await getAgentesFirma();
        setAgentes(agentesTempo);
        const agentesComprasTempo = await getAgentesCompras();
        setAgentesCompras(agentesComprasTempo);
        const edan = agentesTempo.find(agente => agente.IdAgent === 1673);
        handleChange(edan, 'AssignedTo');
        const d = await getPermisoCostosUser(userAuth.idUser);
        if (d.length > 0) {
            setpermisoCostos(d[0].acceso);
        }
    }

    const agregarNuevaFila = () => {
        let newRowData = [...detalles];
        let index = -1 * parseInt((+ (new Date()).getTime() + '').substring(9, 14));
        const newData = {
            DateCreated: new Date(),
            IdEstado: 169,
            EstadoPD: 'Creada',
            NombreProducto: '',
            Description: '',
            Unidad: '',
            Moneda: '',
            Fecha: '',
            ConPrecio: false,
            Currency: "",
            Descuento: 0,
            FechaCotizacion: null,
            FechaPermiso1: null,
            FechaPermiso3: null,
            FechaPermiso4: "",
            Fechapermiso2: null,
            ISV: 0,
            IdCategory: 0,
            IdComponentCategory: 0,
            IdCurrency: 0,
            IdProduct: null,
            IdProveedor: null,
            IdPurcharesRequestDetail: index,
            IdPurchaseRequest: 0,
            IdSalesOrder: null,
            IdSubcategory: null,
            IdTipo: null,
            IdUnit: null,
            IdYarn: null,
            NombreCategoria: "",
            NombreSubCategoria: "",
            NombreTipo: "",
            Permiso1: null,
            Permiso2: null,
            Permiso3: null,
            Permiso4: null,
            Price: 0,
            Proveedor: "",
            Quantity: 0,
            SubTotal: 0,
            Total: 0,
            SubTotalDesc: 0,
            TipoProducto: "",
            UnitName: "",
            UnitPrice: null,
            Inventario: 0
        }
        if (newRowData.length > 0) {
            if (newRowData[newRowData.length - 1].IdProduct) {
                newRowData.push(newData);
            } else {
                newRowData[newRowData.length - 1] = newData;
            }
        } else {
            newRowData.push(newData);
        }
        setDetalles(newRowData)
    }

    const cancelarDetalle = () => {

        selected.forEach((select) => {
            const tempo2 = detalles;
            const index = tempo2.findIndex(detail => detail.IdPurcharesRequestDetail === select.IdPurcharesRequestDetail);
            if (tempo2[index].IdEstado !== 3333) {
                tempo2[index].IdEstado = 3327;
                tempo2[index].EstadoPD = "Cancelado";

                // putEstadoDetalle(tempo2[index].IdPurcharesRequestDetail, tempo2);

                setDetalles(tempo2);
                // detalleRequisicionTable.current.reset();
            } else {
                toastShow(toast, 'error', 'No se puede cancelar', 'El producto ya se encuentra en una Orden de compras.');
            }

        })
        setSelected([]);
    }

    const eliminarItemDetalle = () => {
        if (selected.length > 0) {
            confirmDialog({
                message: 'Esta seguro que desea eliminar este item',
                header: 'Cancelar',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Si",
                accept: () => cancelarDetalle(2),
                rejectLabel: "No",
                style: { backgroundColor: "white" }
            });
        }
        else {
            confirmDialog({
                message: 'Debe seleccionar un detalle',
                header: 'Cancelar',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "OK",
                rejectLabel: " ",
                className: "dialog_detalle",
                style: { backgroundColor: "white" }
            });
        }
    };

    const obtenerRequisa = async () => {
        setLoading(true);
        const areas = await getAreas();
        setAreas(areas);
        const agentesTempo = await getAgentesFirma();
        setAgentes(agentesTempo);
        const agentesComprasTempo = await getAgentesCompras();
        setAgentesCompras(agentesComprasTempo);


        const t = await getRequisa(values.PurchaseRequest);
        if (t.length > 0) {
            const d = await getDetalleRequisa(values.PurchaseRequest);
            setDetalles(d);
            const val = t[0]
            const n = {
                ...val,
                Date: new Date(t[0].Date),
                RequestType: tipos.find(tipo => tipo.tipo === val.RequestType),
                Area: areas.find(area => area.IdArea === val.IdArea),
                Priority: prioridades.find(prioridad => prioridad.prioridad === val.Priority),
                SolicitaN: agentesTempo.find(agente => agente.IdAgent === val.IdSolicita),
                AssignedTo: agentesComprasTempo.find(agente => agente.IdAgent === val.AssignedTo),
            }
            setValues(n);
            setHabilitar(false);
        } else {
            setValues(initialValues)
            setDetalles([]);
            toastShow(toast, 'error', 'Error al obtener', 'No se encontro la requisa.');
        }
        setLoading(false);
    }


    const guardarEncabezado = async () => {
        const bodyEncabezado = {
            ...values,
            Date: getDateTimeStringSQL(new Date(values.Date)),
            IdStatus: values.StatusName.IdStatus ? values.StatusName.IdStatus : 169,
            Usuario: values.UserCreate,
            TienePrecio: 0,
            Departamento: values.Area.IdArea,
            Comentario: values.Comment,
            Tipo: values.RequestType.tipo,
            AssignedTo: (values.AssignedTo.IdAgent ? values.AssignedTo.IdAgent : 1673),
            TotalISV: values.TotalISV,
            TotalDesc: values.TotalDesc,

            Priority: values.Priority.prioridad,
            IdArea: values.Area.IdArea,
            RequestType: values.RequestType.tipo,
            IdSolicita: values.SolicitaN.IdAgent,
        }
        guardarDetalleRequisicion(bodyEncabezado)
    }

    const guardarDetalleRequisicion = async (bodyEncabezado) => {
        let guardar = true;
        if (detalles.length > 0) {
            detalles.forEach((d) => {
                if (d.Producto === '' || d.IdProduct === 0) {
                    toastShow(toast, 'error', 'Error al guardar', 'Todos los items deben contener un producto.');
                    guardar = false;
                } else if (d.Quantity <= 0) {
                    toastShow(toast, 'error', 'Error al guardar', 'Todos los items deben tener una cantidad.');
                    guardar = false;
                }
            })
        } else {
            toastShow(toast, 'error', 'Error al guardar', 'Debe selecionar al menos un producto.');
            guardar = false;
        }



        if (guardar) {
            setLoading(true);
            setHabilitar(true);
            if (bodyEncabezado != null) {

                const Nuevoencabezado = await guardarEncabezadoRequisa(bodyEncabezado);

                if (Nuevoencabezado.length > 0) {
                    const encabezado = Nuevoencabezado[0];
                    const d = await detalles.map((detail) => {
                        detail.IdPurchaseRequest = encabezado.IdPurchaseRequest
                        // ESTADOS EN LOS QUE SE PUEDE MODIFICAR
                        if ([169, 3518, 3600, 3326].includes(detail.IdEstado)) {

                            const rolMantenimiento = [1019, 1045];
                            const AreasMantenimiento = [6, 7, 45, 47, 48, 50, 67];


                            if ((rolMantenimiento.includes(userAuth.IdRol) || AreasMantenimiento.includes(encabezado.IdArea)) && detail.IdTipo !== 6) {
                                detail.IdEstado = 3600
                            } else {
                                switch (detail.IdTipo) {
                                    case 1:
                                        detail.IdEstado = 3326
                                        break;
                                    case 3:
                                        detail.IdEstado = 3326
                                        break;
                                    case 4:
                                        detail.IdEstado = 3326
                                        break;
                                    default:
                                        detail.IdEstado = 3518
                                        break;
                                }
                            }

                            if (encabezado.RequestType !== 'Regalia' && detail.Price <= 0) {
                                if (detail.Permiso4 || [1, 3, 4].includes(detail.IdTipo)) {
                                    detail.IdEstado = 3326
                                } else {
                                    detail.IdEstado = 3518;
                                }
                                detail.FechaCotizacion = null;
                                detail.ConPrecio = null;
                                detail.ISV = 0;
                                detail.subTotal = 0;
                                detail.SubTotalDesc = 0;
                            } else {
                                if (encabezado.RequestType === 'Regalia') {
                                    detail.IdEstado = 3326
                                }
                            }
                        }
                        return setPurchaseDetaillDB(detail);
                    })
                    const n = await guardarDetallesRequisas(d);
                    setHabilitar(false);
                    // sendPurcharePending(purchaseDetaill[0].IdPurchaseRequest);
                    toastShow(toast, 'success', 'Guardado', 'Detalle de requisa guardada exitosamente.');

                    getDetalleRequisa(encabezado.IdPurchaseRequest);
                    toastShow(toast, 'success', 'Guardado', 'Requisa guardada exitosamente.');
                }
                else {
                    toastShow(toast, 'error', 'Error al guardar', 'Todos los campos del encabezado son requeridos.');
                }
            }
        } else {
            toastShow(toast, 'error', 'Error al guardar', 'Todos los campos del encabezado son requeridos.');
        }
        setLoading(false);
    }

    const setPurchaseDetaillDB = (detail) => {
        return {
            IdPurcharesRequestDetail: detail.IdPurcharesRequestDetail,
            IdPurchaseRequest: detail.IdPurchaseRequest,
            IdProduct: detail.IdProduct,
            IdComponentCategory: detail.IdComponentCategory,
            Description: detail.Description,
            IdUnit: detail.IdUnit,
            Quantity: detail.Quantity,
            IdCurrency: detail.IdCurrency,
            Price: detail.Price,
            SubTotal: detail.SubTotal,
            ISV: detail.ISV,
            Descuento: detail.Descuento,
            DateCreated: getDateTimeStringSQL(new Date(detail.DateCreated)),
            IdEstado: detail.IdEstado,
            IdSubcategory: detail.IdSubcategory,
            IdTipo: detail.IdTipo,
            SubTotalDesc: detail.SubTotalDesc,
            FechaCotizacion: detail.FechaCotizacion === null ? null : getDateTimeStringSQL(new Date(detail.FechaCotizacion)),
            ConPrecio: detail.ConPrecio,
            IdProveedor: detail.IdProveedor,
            QuitarFirma: detail.QuitarFirma
        }
    }

    const changeProducto = ({ data }) => {
        return <ProductosOverlayPanel
            rowData={data}
            onChange={({ api, data }, rowData) => {
                const index = detalles.findIndex(detail => detail.IdPurcharesRequestDetail === rowData.IdPurcharesRequestDetail);
                let newDetail = [...detalles];
                newDetail[index].IdProduct = data.IdProductoSuministro;
                newDetail[index].NombreProducto = data.Producto;
                newDetail[index].IdTipo = data.IdTipo;
                newDetail[index].IdCategory = data.IdCategoria;
                newDetail[index].NombreCategoria = data.Categoria;
                newDetail[index].IdSubcategory = data.IdSubCategoria;
                newDetail[index].NombreSubCategoria = data.SubCategoria;
                newDetail[index].UnitName = data.Unidad;
                newDetail[index].IdUnit = data.IdUnit;
                newDetail[index].UnitPrice = data.Costo;
                newDetail[index].Currency = data.Moneda;
                newDetail[index].IdCurrency = data.IdMoneda;
                newDetail[index].IdTipo = data.IdTipo;
                newDetail[index].NombreTipo = data.TipoProducto;
                newDetail[index].Description = data.DescripcionProducto;
                newDetail[index].Inventario = data.Inventario;
                newDetail[index].Quantity = 0;
                newDetail[index].Price = 0;
                newDetail[index].Descuento = 0;
                newDetail[index].ISV = 0;
                newDetail[index].SubTotal = 0;
                newDetail[index].Total = 0;
                newDetail[index].FechaPrecio = 0;
                newDetail[index].ConPrecio = false;
                newDetail[index].Proveedor = null;
                newDetail[index].IdProveedor = null;
                newDetail[index].FechaCotizacion = null;

                const paseTipo = [1, 3, 4]
                if (paseTipo.some(e => e === data.IdTipo)) {
                    newDetail[index].IdEstado = 3326;
                    newDetail[index].EstadoPD = 'Solicitado';
                } else {
                    newDetail[index].IdEstado = 3518;
                    newDetail[index].EstadoPD = 'Pendiente Revisión';
                }
                setDetalles(newDetail);
                api.stopEditing();
            }}
        />

    }

    const changeProveedor = ({ data }) => {
        return <ProveedorOverlayPanel
            rowData={data}
            onChange={({ api, data }, rowData) => {
                console.log({ api, data }, rowData);
                if (selected.length > 0) {
                    let newDetail = [...detalles];
                    const tempo2 = selected.forEach((select) => {
                        const index = detalles.findIndex(detail => detail.IdPurcharesRequestDetail === select.IdPurcharesRequestDetail);
                        newDetail[index].IdProveedor = data.IdCustomer;
                        newDetail[index].Proveedor = data.CustomerName;
                        if (values.RequestType.id === 6) {
                            newDetail[index].IdEstado = 3334;
                            newDetail[index].EstadoPD = 'Cotizado';
                            newDetail[index].ConPrecio = true;
                            newDetail[index].FechaCotizacion = new Date();
                        }
                    });
                    setDetalles(newDetail);
                    api.stopEditing();

                } else {
                    const index = detalles.findIndex(detail => detail.IdPurcharesRequestDetail === rowData.IdPurcharesRequestDetail);
                    let newDetail = [...detalles];
                    newDetail[index].IdProveedor = data.IdCustomer;
                    newDetail[index].Proveedor = data.CustomerName;
                    if (values.RequestType.id === 6) {
                        newDetail[index].IdEstado = 3334;
                        newDetail[index].EstadoPD = 'Cotizado';
                        newDetail[index].ConPrecio = true;
                        newDetail[index].FechaCotizacion = new Date();
                    }
                    setDetalles(newDetail);
                    api.stopEditing();
                }
            }}
        />
    }

    const calcularISV = (newDetail, Price, Quantity) => {
        if (values?.ISV) {
            newDetail.Price = Price;
            newDetail.Quantity = Quantity;
            newDetail.ISV = (Quantity * Price) * 0.15;
            return newDetail
        } else {
            return newDetail;
        }
    }

    const changePrecio = ({ data, oldValue, column }) => {

        const change = () => {

            if ((!data.Proveedor) && column.colId === 'Price') {
                toastShow(toast, 'error', 'Proveedor no valido', 'Debe seleccionar un proveedor antes de ingresar el precio.', 8000);
                return;
            }

            if (((data.Price === 0 && values.RequestType.id !== 6) || typeof Price !== 'number') && column.colId === 'Price') {
                toastShow(toast, 'warn', 'El precio es 0', 'Cambia a estado solicitado.', 8000);
                newDetail[index].IdEstado = 3326;
                newDetail[index].EstadoPD = 'Solicitado';
                newDetail[index].FechaCotizacion = null;
                newDetail[index].ConPrecio = false;
                newDetail[index].SubTotal = 0;
                newDetail[index].SubTotalDesc = 0;
                newDetail[index].ISV = 0;
                newDetail[index].Total = 0;
                newDetail[index].Proveedor = null;
                newDetail[index].Price = 0;
                return;
            }

            if (column.colId === 'Price') {
                newDetail[index].IdEstado = 3334;
                newDetail[index].EstadoPD = 'Cotizado';
                newDetail[index].QuitarFirma = true;
                newDetail[index].FechaCotizacion = new Date();
                newDetail[index].Price = data.Price;
            }

            newDetail[index].SubTotal = (data.Quantity * data.Price);
            newDetail[index] = calcularISV(newDetail[index], data.Price, data.Quantity);
            newDetail[index].SubTotalDesc = (data.Quantity * data.Price) - data.Descuento;
            newDetail[index].Total = ((data.Quantity * data.Price) + (data.ISV - data.Descuento));


            setDetalles(newDetail);
        }

        const notChange = () => {
            newDetail[index][column.colId] = oldValue;
            setDetalles(newDetail);
        }

        const index = detalles.findIndex(detail => detail.IdPurcharesRequestDetail === data.IdPurcharesRequestDetail);
        let newDetail = [...detalles];

        if (estasdosConFirma.includes(newDetail[index].IdEstado)) {
            confirmDialog({
                message: 'Si cambia el precio el item pasara a estado Cotizado.',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: change,
                reject: notChange,
            });
        } else {

            if ([169, 3518].includes(newDetail[index].IdEstado) && column.colId === 'Price') {
                toastShow(toast, 'error', 'No se puede agregrar precio', 'El producto debe estar en estado Solicitado para modificar su precio.', 8000);
                notChange();
                return;
            }
            if ((!data.Proveedor && column.colId === 'Price')) {
                toastShow(toast, 'error', 'Proveedor no valido', 'Debe seleccionar un proveedor antes de ingresar el precio.', 8000);
                notChange();
                return;
            }
            if (((data.Price === 0 && values.RequestType.id !== 6) || typeof data.Price !== 'number') && column.colId === 'Price') {
                toastShow(toast, 'warn', 'El precio es 0', 'Cambia a estado solicitado.', 8000);
                newDetail[index].IdEstado = 3326;
                newDetail[index].EstadoPD = 'Solicitado';
                newDetail[index].FechaCotizacion = null;
                newDetail[index].ConPrecio = false;
                newDetail[index].SubTotal = 0;
                newDetail[index].SubTotalDesc = 0;
                newDetail[index].ISV = 0;
                newDetail[index].Total = 0;
                // newDetail[index].Proveedor = null;
                newDetail[index].Price = 0;
                return;
            }

            if (column.colId === 'Price') {
                newDetail[index].IdEstado = 3334;
                newDetail[index].EstadoPD = 'Cotizado';
                newDetail[index].ConPrecio = true;
                newDetail[index].Price = data.Price;
                newDetail[index].FechaCotizacion = new Date();
            }
            newDetail[index] = calcularISV(newDetail[index], data.Price, data.Quantity);
            newDetail[index].SubTotal = (data.Quantity * data.Price);
            newDetail[index].SubTotalDesc = (data.Quantity * data.Price) - (data.Descuento);
            newDetail[index].Total = ((data.Quantity * data.Price) + (data.ISV - data.Descuento));
            setDetalles(newDetail);

        }
    }

    const changeEstado = ({ data, oldValue, api }, column) => {
        return <div>
            <Dropdown
                value={estados.filter(e => e.IdStatus === data.IdEstado)[0]}
                options={estados}
                optionLabel="StatusName"
                filter
                filterBy="StatusName"
                onChange={(e) => {
                    if (selected.length === 0) {
                        const index = detalles.findIndex(detail => detail.IdPurcharesRequestDetail === data.IdPurcharesRequestDetail);
                        let newDetail = [...detalles];
                        newDetail[index].IdEstado = e.value.IdStatus;
                        newDetail[index].EstadoPD = e.value.StatusName;
                        setDetalles(newDetail);
                        api.stopEditing();
                    }
                    else {
                        let tempo2 = [...detalles];
                        selected.forEach((select) => {
                            const index = tempo2.findIndex(detail => detail.IdPurcharesRequestDetail === select.IdPurcharesRequestDetail);
                            tempo2[index].IdEstado = e.value.IdStatus;
                            tempo2[index].EstadoPD = e.value.StatusName;
                        });
                        setDetalles(tempo2);
                    }
                }}
            />
        </div>
    }

    const changeCurrency = ({ data, oldValue, api }, column) => {
        return <div>
            <Dropdown
                value={currencys.filter(e => e.IdCurrency === data.IdCurrency)[0]}
                options={currencys}
                optionLabel="Currency"
                filter
                filterBy="Currency"
                onChange={(e) => {
                    if (selected.length > 0) {
                        let tempo2 = [...detalles];
                        selected.forEach((select) => {
                            const index = tempo2.findIndex(detail => detail.IdPurcharesRequestDetail === select.IdPurcharesRequestDetail);
                            tempo2[index].IdCurrency = e.value.IdCurrency;
                            tempo2[index].Currency = e.value.Currency;
                        });
                        setDetalles(tempo2);
                    } else {
                        let newDetail = [...detalles];
                        const index = detalles.findIndex(detail => detail.IdPurcharesRequestDetail === data.IdPurcharesRequestDetail);
                        newDetail[index].IdCurrency = e.value.IdCurrency;
                        newDetail[index].Currency = e.value.Currency;
                        setDetalles(newDetail);
                    }
                    api.stopEditing();
                }}
            />
        </div>
    }

    const changeUnidad = ({ data, oldValue, api }, column) => {
        return <div>
            <Dropdown
                value={units.filter(e => e.IdUnit === data.IdUnit)[0]}
                options={units}
                optionLabel="UnitName"
                filter
                filterBy="UnitName"
                onChange={(e) => {
                    if (selected.length > 0) {
                        let tempo2 = [...detalles];
                        selected.forEach((select) => {
                            const index = tempo2.findIndex(detail => detail.IdPurcharesRequestDetail === select.IdPurcharesRequestDetail);
                            tempo2[index].IdUnit = e.value.IdUnit;
                            tempo2[index].UnitName = e.value.UnitName;
                        });
                        setDetalles(tempo2);
                    } else {
                        let newDetail = [...detalles];
                        const index = detalles.findIndex(detail => detail.IdPurcharesRequestDetail === data.IdPurcharesRequestDetail);
                        newDetail[index].IdUnit = e.value.IdUnit;
                        newDetail[index].UnitName = e.value.UnitName;
                        setDetalles(newDetail);
                    }
                }
                }
            />
        </div>
    }


    const columns = [
        {
            header: 'ID',
            field: 'IdPurcharesRequestDetail',
            className: "Xsmall",
            frozen: "frozen",
            alignFrozen: "left",
            hidden: userAuth?.IdRol === 1
        },
        {
            header: 'DateCreated',
            field: 'DateCreated',
            frozen: true,
            Format: 'DateTime',
        },
        {
            header: 'EstadoPD',
            field: 'EstadoPD',
            frozen: true,
            className: 'medium',
            editable: habilitar && userAuth.IdRol === 1,
            cellEditor: changeEstado,
            Format: 'Estado',
            body: rowData => ({ ID: rowData.IdEstado, Estado: rowData.EstadoPD }),
        },
        {
            header: 'NombreProducto',
            field: 'NombreProducto',
            frozen: true,
            className: 'Xlarge',
            editable: habilitar,
            cellEditor: changeProducto
        },
        {
            header: 'Description',
            field: 'Description',
            className: 'Xlarge',
            editable: habilitar,
        },
        {
            header: 'Tipo',
            field: 'NombreTipo',
            className: 'Xsmall',
        },
        {
            header: 'Proveedor',
            field: 'Proveedor',
            className: 'Xlarge',
            editable: habilitar,
            cellEditor: changeProveedor

        },
        {
            header: 'Categoria',
            field: 'NombreCategoria',
        },
        {
            header: 'SubCategoria',
            field: 'NombreSubCategoria',
            className: 'small',
        },
        {
            header: 'Unidad',
            field: 'UnitName',
            className: 'Xsmall',
            editable: habilitar,
            cellEditor: changeUnidad
        },
        {
            header: 'Moneda',
            field: 'Currency',
            className: 'Xsmall',
            editable: habilitar,
            cellEditor: changeCurrency
        },
        {
            header: 'ConPrecio',
            field: 'ConPrecio',
            className: 'Xsmall',
        },
        {
            header: 'FechaPrecio',
            field: 'FechaCotizacion',
            Format: 'DateTime',
        },
        {
            field: 'PurchaseOrder',
            header: 'Orden Compra',
            headerEn: 'Purchase Order',
            className: 'small',
            Format: 'Center',
            onCellDoubleClicked: ({ data }) => {
                if (data.PurchaseOrder && [1, 8, 1047].includes(userAuth?.IdRol)) {
                    setOrdenDialog(true)
                    setOrderToShow(data?.PurchaseOrder)
                }
            }
        },
        {
            header: 'Inventario',
            field: 'Inventario',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            header: 'Quantity',
            field: 'Quantity',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            editable: habilitar,
            onChange: (data) => changePrecio(data),
            Frozen: true,
            alignFrozen: 'right'
        },
        {
            header: 'Price',
            field: 'Price',
            className: 'small',
            Format: 'Decimal',
            editable: habilitar,
            onChange: (data) => changePrecio(data),
            hidden: permisoCostos
        },
        {
            header: 'Descuento',
            field: 'Descuento',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            editable: habilitar,
            onChange: (data) => changePrecio(data),
            hidden: permisoCostos
        },
        {
            header: 'ISV',
            field: 'ISV',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            editable: habilitar,
            onChange: (data) => changePrecio(data),
            hidden: permisoCostos
        },
        {
            header: 'SubTotal',
            field: 'SubTotal',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            hidden: permisoCostos,
            Frozen: true,
            alignFrozen: 'right'
        },
        {
            header: 'Total',
            field: 'Total',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            hidden: permisoCostos,
            Frozen: true,
            alignFrozen: 'right'
        },
    ];

    const table = {
        Columns: columns,
        Data: detalles,
        selected: selected,
        setSelected: setSelected,
    }

    useEffect(() => {
        getInfo();
        setDetalles([]);
        if (idRequisa || values.PurchaseRequest > 0) {
            obtenerRequisa()
        } else {
            getInfoNew()
        }

    }, [idRequisa])

    useEffect(() => {
        setValues({
            ...values,
            TotalISV: detalles.reduce((a, b) => a + b.ISV, 0),
            TotalDesc: detalles.reduce((a, b) => a + b.Total, 0),
        })
    }, [detalles])


    return (
        <div>
            <Loader loading={loading} />
            <Toast position="bottom-right" ref={toast} />
            <ConfirmDialog />
            <EncabezadoRequisicion
                values={values}
                handleInputChange={handleInputChange}
                handleChange={handleChange}
                agregarNuevaFila={agregarNuevaFila}
                setHabilitar={setHabilitar}
                eliminarItemDetalle={eliminarItemDetalle}
                toast={toast}
                resetForm={resetForm}
                detalles={detalles}
                table={table}
                getRequisa={obtenerRequisa}
                habilitar={habilitar}
                guardarEncabezado={guardarEncabezado}
                setValues={setValues}
                areas={areas}
                agentes={agentes}
                agentesCompras={agentesCompras}
            />
            <Card
                contenido={
                    <div style={{ height: '70vh' }}>
                        <AgGrid table={table} />
                    </div>
                }
            />


            <ModalFull
                header='Orden de compras'
                visible={ordenDialog}
                onHide={onHideModalOC}
                contenido={
                    <OrdenesComprasCrud
                        PurchaseOrder={orderToShow}
                        ordenDialog={ordenDialog}
                        setOrdenDialog={setOrdenDialog}
                        habilitar={habilitarOrden}
                        setHabilitar={setHabilitarOrden} />
                }
            />


        </div>
    )
}

export default RequisaComprasModalCrud